import React from "react";
import Service from "../cards/serviceCard";
import { useContext } from "react";
import { ServiceContext } from "../../App";
import { Link } from "react-router-dom";
import Slider from "../common/Slider";
import { getSliderSettings } from "./recentJobGroup";
import ServicePageSkeleton from "../pages/skeletons/servicePage";
import Button from "../common/Button";

function ServiceGroup({ type }: any) {
  const { service, serviceLoading } = useContext(ServiceContext);
  const safeService = Array.isArray(service) ? service : [];

  const settings = getSliderSettings({
    dots: false,
    arrows: true,
    slidesToShow: 3,
    removeAutoPlay: false,
    slidesToShowAt1024Breakpoint: 2,
    slidesToShowAt992Breakpoint: 1,
    objectCount: safeService.length,
    speed: 500,
    autoplaySpeed: 15000,
  });

  return (
    <>
      {serviceLoading && (
        <ServicePageSkeleton numberOfCols={3} isTitle={true} />
      )}

      {safeService.length === 0 ? null : (
        <section>
          {type ? (
            <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 md:cht-py-16">
              <header className="cht-text-center cht-mb-10 cht-space-y-2">
                <h2 className="!cht-font-heading cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b]">
                  Our Services
                </h2>
                <p className="cht-text-slate-500 cht-text-base cht-font-medium">
                  Discover Our Exceptional Enterprise & Digital Solutions
                </p>
              </header>

              <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
                {safeService.slice(0, 6).map((item: any) => (
                  <Service
                    key={item?.id || item?.slug}
                    id={item?.id}
                    slug={item?.slug}
                    title={item?.title}
                    body={item?.safe_description_html}
                    image={item?.get_image_url}
                    category={item?.category}
                    technologies={item?.technologies}
                  />
                ))}
              </div>

              {safeService.length > 6 && (
                <div className="cht-flex cht-justify-center cht-mt-10">
                  <Button
                    to="/services"
                    variant="primary"
                    size="md"
                  >
                    See all Services
                  </Button>
                </div>
              )}
            </section>
          ) : (
            <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 md:cht-py-16">
              <header className="cht-text-center cht-mb-10 cht-space-y-2">
                <h2 className="!cht-font-heading cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b]">
                  What We Do
                </h2>
                <p className="cht-text-slate-500 cht-text-base cht-font-medium">
                  Discover Our Exceptional Enterprise & Digital Solutions
                </p>
              </header>

              <Slider {...settings}>
                {safeService.map((item: any) => (
                  <div key={item?.id || item?.slug} className="cht-px-3 cht-py-2 cht-h-full">
                    <Service
                      id={item?.id}
                      slug={item?.slug}
                      title={item?.title}
                      body={item?.safe_description_html}
                      image={item?.get_image_url}
                      category={item?.category}
                      technologies={item?.technologies}
                    />
                  </div>
                ))}
              </Slider>

              {safeService.length > 1 && (
                <div className="cht-flex cht-justify-center cht-mt-10">
                  <Button
                    to="/services"
                    variant="primary"
                    size="md"
                  >
                    See all Services
                  </Button>
                </div>
              )}
            </section>
          )}
        </section>
      )}
    </>
  );
}

export default ServiceGroup;
